<label for="row-selector-{{ id }}" class="sr-only">{{locale "selectRow"}}</label>
<input
  type="checkbox"
  id="row-selector-{{ id }}"
  class="column-row-selector {{#if groupId }}row-selector-group-{{ groupId }}{{/if}}"
  value="{{ value }}"
  data-model-cid="{{ id }}"
  {{#if checked }}checked{{/if}}
/>
<span class="pseudoCheckbox" />
